import React from 'react';
import { Link } from 'react-router-dom';
import ProductBlock from './productBlock';

const RelatedProducts = ({ products, product, delay, handleLoading }) => {
  return (
    <div className='related-products container'>
      <h2 className='featured-products-heading'>Related Products</h2>
      <div className='row'>
        {products
          .filter((p) => p._id !== product._id)
          .filter((p) => p.category === product.category)
          .slice(0, 4)
          .map((p) => (
            <div
              // onClick={() => this.setState({ loading: true })}
              className='col-6 col-lg-3 col-md-4 col-sm-6 product'
              key={p._id}
            >
              <ProductBlock
                id={p._id}
                key={p._id}
                label={p.label}
                price={p.price}
                imageUrl={p.imageUrl}
                handleLoad={handleLoading}
                animationDelayz={(delay += 0.06)}
              />
            </div>
          ))}
      </div>

      <div className='category-btn'>
        <Link to='/products/'>
          <button className='explore-categories'>View All</button>
        </Link>
      </div>
    </div>
  );
};

export default RelatedProducts;
